




































import {
  Vue,
  getCookie,
  cookies,
} from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("trip-details", {
  data() {
    return {
      staticContent,
      restLang: getCookie(cookies.lang) == "AR" ? "Ar" : "En",
    };
  },
  props: {
    Track: Boolean,
  },
  mounted() {
    this.startTracking();
  },
  computed: {
    selectedTrip() {
      return this.$store.state.selectedTrip;
    },
    isRTL() {
      return this.$root.isRTL;
    },
  },
  methods: {
    startTracking() {
      this.getSelectedTripStateDetails();
      this.$root.user.orderTracking = setInterval(() => {
        this.getSelectedTripStateDetails();
      }, 1000 * 60); // get status after each 20 sec
    },
    stopTracking() {
      clearInterval(this.$root.user.orderTracking);
    },
    getSelectedTripStateDetails() {
      this.$store
        .dispatch("GET_SPECIFIC_TRIP_STATUS", this.$root.selectedTrip.uuid)
        .then((res) => {
          if (
            res.status === "Delivered" ||
            res.status === "Canceled" ||
            res.status === "Rejected"
          ) {
            this.stopTracking();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
});
